// Folder type definitions

export interface Folder {
  id: string;                    // Local database ID (UUID)
  serverId: string;             // MongoDB _id from server (for sync)
  userId?: string;               // User ID (for multi-user support)
  name: string;                  // Folder name (required, max 50 chars)
  description?: string;          // Folder description (optional, max 200 chars)
  color?: string;                // Hex color code (e.g., "#6366F1")
  icon?: string;                 // Icon identifier (e.g., "folder", "briefcase")
  position: number;              // Sort order (0, 1, 2, ...)
  bookmarkCount?: number;        // Number of bookmarks (computed)
  createdAt: number;             // Timestamp (milliseconds)
  updatedAt: number;             // Timestamp (milliseconds)
}

export interface FolderWithCount extends Folder {
  bookmarkCount: number;
}

export interface CreateFolderData {
  name: string;
  description?: string;
  color?: string;
  icon?: string;
  position?: number;
}

export interface SyncResult {
  success: boolean;
  synced: number;
  failed: number;
  errors: string[];
}

export interface ClassificationResult {
  folderId: string | null;
  confidence: number;
  reasoning: string;
}

// Server folder interface to match API response
export interface ServerFolder {
  _id: string;
  userId: string;
  name: string;
  description?: string;
  color?: string;
  icon?: string;
  position: number;
  bookmarkCount?: number;
  createdAt: string;
  updatedAt: string;
}

// Preset colors for folders
export const PRESET_COLORS = [
  '#6366F1', // Indigo
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#F59E0B', // Amber
  '#10B981', // Emerald
  '#3B82F6', // Blue
  '#EF4444', // Red
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#84CC16', // Lime
  '#06B6D4', // Cyan
  '#A855F7', // Violet
];

// Preset icons for folders (FontAwesome 6 compatible)
export const PRESET_ICONS = [
  'folder',
  'briefcase',
  'book',
  'palette',
  'cart-shopping',
  'newspaper',
  'utensils',
  'plane',
  'laptop-code',
  'heart',
  'star',
  'tag',
  'bookmark',
  'file',
  'image',
  'video',
];

// General folder name constants
export const GENERAL_FOLDER_NAMES = 'Others';

// Public folder (no auth) - for GET /folders/public and GET /folders/public/:slug
export interface PublicFolder {
  slug: string;
  name: string;
  description?: string;
  color?: string;
  icon?: string;
  bookmarkCount?: number;
  bookmarks?: PublicFolderBookmark[];
}

export interface PublicFolderBookmark {
  id: string;
  url?: string;
  title?: string;
  description?: string;
  image?: string;
  source?: string;
  addedOn?: number;
}

